export default __webpack_public_path__ + "static/media/warning--hairpin-curve-right--g3.193a361e.png";